import { DataService } from '@/api'
import EmailPreferencesMap from '@/lib/email-preferences.map'
import { capitalize } from '@/lib/generic.utils'
import { get } from 'lodash'
import { make } from 'vuex-pathify'

const state = {
  all: [],
  single: null,
  emailPreferences: null,
  emailPreferenceOptions: null,
  addressTypes: null
}

const actions = make.actions(state)
const mutations = make.mutations(state)
const getters = make.getters(state)
const SERVICE = new DataService('contacts')

export default {
  namespaced: true,
  state,
  actions: {
    ...actions,
    create(context, params) {
      return SERVICE.create(params).then(response => response.data.result)
    },
    update(context, params) {
      return SERVICE.update(params)
        .then(response => response.data.result)
        .catch(err => err)
    },
    deleteSingle(context, params) {
      return SERVICE.delete(params).then(response => response.data.result)
    },
    getCreateFormData(context, params) {
      return SERVICE.getCreateFormData(params)
        .then(response => {
          context.commit('SET_EMAIL_PREFERENCES', response.data.result.email_preferences)
          context.commit('SET_EMAIL_PREFERENCE_OPTIONS', response.data.result.email_preferences)
          context.commit('SET_ADDRESS_TYPES', response.data.result.address_types)
        })
        .catch(err => err)
    }
  },
  getters,
  mutations: {
    ...mutations,
    SET_EMAIL_PREFERENCE_OPTIONS(state, data) {
      state.emailPreferenceOptions = data.map(item => ({
        label: get(EmailPreferencesMap, item.name, capitalize(item.name.replace('_', ' '))),
        value: item.id
      }))
    }
  }
}
